namespace TabAurous.ECommerce {
    export interface ECommOrderAddressRow {
        AddressId?: number;
        Type?: number;
        TransId?: number;
        Address1?: string;
        POSCustomerId?: number;
        City?: number;
        State?: number;
        Country?: number;
        Pincode?: string;
        CityName?: string;
        StateName?: string;
        CountryName?: string;
        Phone?: string;
    }

    export namespace ECommOrderAddressRow {
        export const idProperty = 'AddressId';
        export const nameProperty = 'Address1';
        export const localTextPrefix = 'ECommerce.ECommOrderAddress';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            AddressId = "AddressId",
            Type = "Type",
            TransId = "TransId",
            Address1 = "Address1",
            POSCustomerId = "POSCustomerId",
            City = "City",
            State = "State",
            Country = "Country",
            Pincode = "Pincode",
            CityName = "CityName",
            StateName = "StateName",
            CountryName = "CountryName",
            Phone = "Phone"
        }
    }
}
